
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.35","height":"16.401","viewBox":"0 0 14.35 16.401"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.35 6.726v-2.8a3.871 3.871 0 01-2.142-.643 3.917 3.917 0 01-1.727-2.57 3.856 3.856 0 01-.06-.678V.002H7.595v11.193a2.392 2.392 0 01-2.391 2.391A2.392 2.392 0 012.815 11.2a2.392 2.392 0 012.391-2.4 2.387 2.387 0 01.717.11V6.03a5.17 5.17 0 00-.715-.049A5.211 5.211 0 000 11.189 5.211 5.211 0 005.208 16.4a5.211 5.211 0 005.209-5.205V5.469a6.719 6.719 0 003.917 1.258z","fill":"#fff"}})])
          )
        }
      }
    